import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { Grid, Paper, ListItem } from '@material-ui/core'
import EditActionComponent from '../../../components/common/EditActionComponent'
import ContainerWithTitle from '../../../containers/HOC/ContainerWithTitle'
import {
  getNotificationsList,
  updateNotificationsList,
  updateShop,
  getShopTerminals,
} from '../../../actions/shop'
import { checkEmail } from '../../../utils/validations/common'
import { openErrorMessage } from '../../../actions/message'
import { memberNotifications, companyNotifications, Appcues } from '../../../utils/constants'
import { hasAccess } from '../../../utils/api'
import NotificationItem from '../../../components/Notifications/NotificationItem'

class Notifications extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      editMode: false,
      notifications: [],
      editIndex: 0,
      terminals: {},
      dataShop: {},
    }
  }

  componentDidMount() {
    const { assignedShop = {} } = this.props.authReducer.session
    this.updateNotifications()
    this.props.dispatch(getShopTerminals(assignedShop.id)).then((res) => {
      this.setState({
        terminals: res,
        dataShop: assignedShop,
      })
    })
  }

  updateNotifications = () => {
    this.props.dispatch(getNotificationsList()).then((res) => {
      this.setState({
        notifications: res,
      })
    })
  }

  validateNotification = () => {
    let { notifications = [], dataShop = {} } = this.state

    let errorMsg = ''

    for (let notification of notifications) {
      if (notification.defaultEmail) {
        let emails = notification.defaultEmail && notification.defaultEmail.split(',')
        let filtered = emails.length > 0 && emails.filter((email) => checkEmail(email))
        if (filtered.length !== emails.length) {
          errorMsg = 'Please provide valid email.'
          break
        }
        /* else{
                    //this.onSave({...notification, defaultEmail : filtered.toString() , defaultNumber : notification.defaultNumber })
                    defaultEmail = filtered.toString();
                    defaultNumber = notification.defaultNumber;
                } */
      }
      if (notification.notificationType === 'Incoming_Order' && notification.defaultNumber) {
        let phones = notification.defaultNumber && notification.defaultNumber.split(',')

        let validNumbers =
          phones.length > 0 && phones.filter((phone) => !isNaN(phone) && phone.length === 10)

        //let filtered = validNumbers.length > 0 && validNumbers.map(phone => this.addMask(phone)).filter(phone => checkPhone(phone))

        if (validNumbers.length !== phones.length) {
          errorMsg = 'Please provide valid phone number with 10 digits.'
          break
        }
        /* else if(filtered.length !== phones.length){
                    return  this.props.dispatch(openErrorMessage("Please provide valid phone number."))
                } */
        /*  else{
                     //this.onSave({...notification, defaultEmail : notification.defaultEmail , defaultNumber : filtered.toString()})
                     defaultEmail = notification.defaultEmail;
                     defaultNumber = validNumbers.toString();
                 } */
      }
    }

    if (errorMsg) {
      this.props.dispatch(openErrorMessage(errorMsg))
    } else {
      this.onSave(notifications, dataShop)
    }
  }

  onChangeNotifications = (index, key) => (event) => {
    const { notifications = [] } = this.state

    const dataToUpdate = notifications[index]

    const updatedData = { ...dataToUpdate, [key]: event.target.checked }

    let updatedNotifications = [...notifications]

    updatedNotifications[index] = { ...updatedData }

    this.setState({
      notifications: updatedNotifications,
    })
  }

  onChangeShopNotifications = (key, isCheckBox) => (e) => {
    const { dataShop = {} } = this.state
    const value = isCheckBox ? e.target.checked : e.target.value
    const dataUpdated = { ...dataShop, [key]: value }
    let updatedDataShop = { ...dataUpdated }

    this.setState({ dataShop: updatedDataShop })
  }

  onSave = (notifications, dataShop) => {
    Appcues.track('Notification Settings Saved')
    //let { notifications = [] , editIndex = 0 } = this.state
    this.props.dispatch(updateNotificationsList(notifications)).then((res) => {
      //notifications[editIndex] = res
      this.setState({
        notifications: res,
      })
    })
    this.props.dispatch(updateShop(dataShop)).then((res) => {
      this.setState({
        dataShop: res,
      })
    })
    this.disableEdit()
  }

  onCancel = () => {
    const { notificationsList = [] } = this.props.shopReducer
    const { assignedShop = {} } = this.props.authReducer.session
    //const { values=[] } = notificationsList || {};
    //console.log(notificationsList, "notificationsList")
    this.setState({
      editMode: false,
      notifications: notificationsList,
      dataShop: assignedShop,
    })
    //this.disableEdit();
  }

  enableEdit = () => {
    this.setState({ editMode: true })
  }

  disableEdit = () => {
    this.setState({ editMode: false })
  }

  onChangeCreatableOptions = (index, key, values) => {
    const { notifications = [] } = this.state
    const dataToUpdate = notifications[index]
    let updatedValues = []
    if (key === 'defaultEmail') {
      updatedValues = values.map((value) => value.value) || []
    }
    if (key === 'defaultNumber') {
      updatedValues = values.map((value) => value.value) || []
    }
    //console.log( values, "values")
    const updatedData =
      key !== 'maxCashDrawerLimit'
        ? { ...dataToUpdate, [key]: updatedValues.length ? updatedValues.toString() : null }
        : { ...dataToUpdate, [key]: values }
    let updatedNotifications = [...notifications]

    updatedNotifications[index] = { ...updatedData }
    this.setState({
      notifications: updatedNotifications,
      editIndex: index,
    })
  }

  onChangeNotificationTerminals = (key) => (values) => {
    const { dataShop = {} } = this.state
    let updatedValues =
      (values &&
        values.length &&
        values.map((value) => {
          return value.value
        })) ||
      []

    const updatedData = { ...dataShop, [key]: updatedValues }
    let updatedDataShop = { ...updatedData }

    this.setState({ dataShop: updatedDataShop })
  }

  render() {
    const { appTarget = 'Retail' } =
      (this.props.authReducer.session && this.props.authReducer.session.assignedShop) || {}
    const { editMode = false, notifications = [], terminals = {}, dataShop = {} } = this.state

    const updatedNotifications = notifications.map((notification, index) => {
      return { ...notification, index }
    })

    const orderNotifications = updatedNotifications.filter((notification) => {
      return !Object.keys(memberNotifications).find(
        (memberNotification) => notification.notificationType === memberNotification,
      )
    })

    const filteredMemberNotifications = updatedNotifications.filter((notification) => {
      return Object.keys(memberNotifications).find(
        (memberNotification) => notification.notificationType === memberNotification,
      )
    })

    const filteredCompanyNotifications = updatedNotifications.filter((notification) =>
      Object.keys(companyNotifications).find(
        (companyNotification) => notification.notificationType === companyNotification,
      ),
    )
    return (
      <div>
        <Grid container>
          {notifications.length > 0 && (
            <Grid item xs={12} sm={12} md={12} lg={12}>
              {hasAccess() ? (
                <div className="pull-right margin-bottom-small">
                  <EditActionComponent
                    onSave={this.validateNotification}
                    onCancel={this.onCancel}
                    onEdit={this.enableEdit}
                    editMode={editMode}
                  />
                </div>
              ) : (
                <div className="pull-right margin-bottom-small"></div>
              )}
            </Grid>
          )}
          <Grid container>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <Paper className="paper-page">
                {notifications.length > 0 ? (
                  orderNotifications.map((notification, index) => {
                    /* let defaultEmail = notification.defaultEmail != null ? notification.defaultEmail.split(',') : []
                                    let defaultNumber = notification.defaultNumber != null ? notification.defaultNumber.split(',') : [] */

                    return (
                      <NotificationItem
                        key={index}
                        label={`${
                          notification.notificationType &&
                          notification.notificationType.replace(/_/g, ' ')
                        } Notification`}
                        index={notification.index}
                        notification={notification}
                        onChangeNotifications={this.onChangeNotifications}
                        onChangeCreatableOptions={this.onChangeCreatableOptions}
                        editMode={editMode}
                        dataShop={dataShop}
                        onChangeShopNotifications={this.onChangeShopNotifications}
                        onChangeNotificationTerminals={this.onChangeNotificationTerminals}
                        terminals={terminals}
                      />
                    )
                  })
                ) : (
                  <ListItem>No notification information available for the selected shop.</ListItem>
                )}
              </Paper>
            </Grid>
          </Grid>
          {appTarget !== 'Grow' ? (
            <Grid container>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <Paper className="paper-page">
                  <ListItem>
                    <h4>Member Notifications</h4>
                  </ListItem>
                  {notifications.length > 0 ? (
                    filteredMemberNotifications.map((notification, index) => {
                      /* let defaultEmail = notification.defaultEmail != null ? notification.defaultEmail.split(',') : []
                                    let defaultNumber = notification.defaultNumber != null ? notification.defaultNumber.split(',') : [] */

                      return (
                        <NotificationItem
                          key={index}
                          label={memberNotifications[notification.notificationType]}
                          index={notification.index}
                          notification={notification}
                          onChangeNotifications={this.onChangeNotifications}
                          onChangeCreatableOptions={this.onChangeCreatableOptions}
                          editMode={editMode}
                          hideEmail={true}
                        />
                      )
                    })
                  ) : (
                    <ListItem>
                      No notification information available for the selected shop.
                    </ListItem>
                  )}
                </Paper>
              </Grid>
            </Grid>
          ) : null}
          {appTarget === 'Distribution' ? (
            <Grid container>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <Paper className="paper-page">
                  <ListItem>
                    <h4>Company Notifications</h4>
                  </ListItem>
                  {filteredCompanyNotifications.length > 0 ? (
                    filteredCompanyNotifications.map((notification, index) => {
                      return (
                        <NotificationItem
                          key={index}
                          label={companyNotifications[notification.notificationType]}
                          index={notification.index}
                          notification={notification}
                          onChangeNotifications={this.onChangeNotifications}
                          onChangeCreatableOptions={this.onChangeCreatableOptions}
                          editMode={editMode}
                          hideEmail={true}
                        />
                      )
                    })
                  ) : (
                    <ListItem>
                      No company notification information available for the selected shop.
                    </ListItem>
                  )}
                </Paper>
              </Grid>
            </Grid>
          ) : null}
        </Grid>
      </div>
    )
  }
}

export default connect(({ dispatch, shopReducer, companyReducer, authReducer }) => ({
  dispatch,
  shopReducer,
  companyReducer,
  authReducer,
}))(ContainerWithTitle(Notifications, 'Notifications'))



// WEBPACK FOOTER //
// ./src/containers/Settings/Shop/Notifications.js